import { c as _c } from "react/compiler-runtime";
import React, { useEffect, useRef, useState } from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';
import ModularProductCard from './ModularProductCard';
const ModularTopNavItems = t0 => {
  const $ = _c(11);
  const {
    isNavFixed: t1,
    collectionData,
    activeCollectionId,
    onTopNavClick
  } = t0;
  const isNavFixed = t1 === undefined ? false : t1;
  let t2;
  if ($[0] !== activeCollectionId || $[1] !== collectionData || $[2] !== isNavFixed || $[3] !== onTopNavClick) {
    let t3;
    if ($[5] !== activeCollectionId || $[6] !== isNavFixed || $[7] !== onTopNavClick) {
      t3 = collection => <ModularProductCard key={collection.name} className={cx({
        "![border-bottom:2px_solid_#107c8c]": isNavFixed && activeCollectionId === collection.id
      })} product={{
        ...collection.products[0],
        options: collection.options,
        collection: collection.name
      }} displayType="collection" onClick={() => {
        if (onTopNavClick) {
          onTopNavClick(collection.id);
        }
      }} isFixed={isNavFixed} thumbnail={collection.thumbnail} />;
      $[5] = activeCollectionId;
      $[6] = isNavFixed;
      $[7] = onTopNavClick;
      $[8] = t3;
    } else {
      t3 = $[8];
    }
    t2 = collectionData.map(t3);
    $[0] = activeCollectionId;
    $[1] = collectionData;
    $[2] = isNavFixed;
    $[3] = onTopNavClick;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[9] !== t2) {
    t3 = <>{t2}</>;
    $[9] = t2;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  return t3;
};

// Active-section highlight, kept local so scroll re-renders the nav, not the list
const useActiveCollection = collectionData => {
  const $ = _c(5);
  const [activeCollectionId, setActiveCollectionId] = useState(null);
  let t0;
  if ($[0] !== collectionData) {
    t0 = collectionData.map(_temp).join(",");
    $[0] = collectionData;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const collectionIdsKey = t0;
  let t1;
  let t2;
  if ($[2] !== collectionIdsKey) {
    t1 = () => {
      if (typeof IntersectionObserver === "undefined" || !collectionIdsKey) {
        return;
      }
      const elements = collectionIdsKey.split(",").map(_temp2).filter(Boolean);
      if (!elements.length) {
        return;
      }
      const observer = new IntersectionObserver(() => {
        const topMost = elements.map(_temp3).filter(_temp4).sort(_temp5)[0];
        if (topMost) {
          setActiveCollectionId(topMost.id);
        }
      }, {
        rootMargin: "-80px 0px -60% 0px",
        threshold: 0
      });
      elements.forEach(el_0 => observer.observe(el_0));
      return () => observer.disconnect();
    };
    t2 = [collectionIdsKey];
    $[2] = collectionIdsKey;
    $[3] = t1;
    $[4] = t2;
  } else {
    t1 = $[3];
    t2 = $[4];
  }
  useEffect(t1, t2);
  return activeCollectionId;
};

// Pin the bar once the nav reaches the top (past the hero). Scroll listener over
// IntersectionObserver: the nav starts below the fold, where a fast scroll can
// skip the observer flip.
const useNavFixed = navRef => {
  const $ = _c(3);
  const [isNavFixed, setIsNavFixed] = useState(false);
  let t0;
  let t1;
  if ($[0] !== navRef) {
    t0 = () => {
      const nav = navRef.current;
      if (typeof window === "undefined" || !nav) {
        return;
      }
      let frame = null;
      const update = () => {
        frame = null;
        setIsNavFixed(nav.getBoundingClientRect().top <= 0);
      };
      const onScroll = () => {
        if (frame === null) {
          frame = window.requestAnimationFrame(update);
        }
      };
      update();
      window.addEventListener("scroll", onScroll, {
        passive: true
      });
      window.addEventListener("resize", onScroll, {
        passive: true
      });
      return () => {
        window.removeEventListener("scroll", onScroll);
        window.removeEventListener("resize", onScroll);
        if (frame !== null) {
          window.cancelAnimationFrame(frame);
        }
      };
    };
    t1 = [navRef];
    $[0] = navRef;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
  return isNavFixed;
};
const ModularTopNav = t0 => {
  const $ = _c(18);
  const {
    collectionData: t1,
    onTopNavClick: t2
  } = t0;
  let t3;
  if ($[0] !== t1) {
    t3 = t1 === undefined ? [] : t1;
    $[0] = t1;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const collectionData = t3;
  const onTopNavClick = t2 === undefined ? null : t2;
  const navRef = useRef(null);
  const isNavFixed = useNavFixed(navRef);
  const activeCollectionId = useActiveCollection(collectionData);
  let t4;
  if ($[2] !== activeCollectionId || $[3] !== collectionData || $[4] !== onTopNavClick) {
    t4 = <div ref={navRef} className="bg-white w-full max-[767px]:p-5 pt-12"><div className="grid grid-cols-[repeat(auto-fit,minmax(130px,48%)_)] gap-[10px] md:flex md:flex-wrap md:items-center md:justify-center"><ModularTopNavItems collectionData={collectionData} activeCollectionId={activeCollectionId} onTopNavClick={onTopNavClick} /></div></div>;
    $[2] = activeCollectionId;
    $[3] = collectionData;
    $[4] = onTopNavClick;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== isNavFixed) {
    t5 = cx("bg-white w-full h-[54px] left-0 opacity-0 pointer-events-none fixed top-0 transition-[opacity_.2s_ease-out] z-[5000] max-[767px]:p-0", {
      "opacity-100 pointer-events-auto transition-[opacity_.2s_ease-in]": isNavFixed
    });
    $[6] = isNavFixed;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== activeCollectionId || $[9] !== collectionData || $[10] !== onTopNavClick) {
    t6 = <div className="md:items-center md:justify-center bg-white [border-bottom:1px_solid_#e5e5e5] flex flex-row flex-nowrap w-full max-[767px]:overflow-x-auto"><ModularTopNavItems isNavFixed={true} collectionData={collectionData} activeCollectionId={activeCollectionId} onTopNavClick={onTopNavClick} /></div>;
    $[8] = activeCollectionId;
    $[9] = collectionData;
    $[10] = onTopNavClick;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t5 || $[13] !== t6) {
    t7 = <div className={t5}>{t6}</div>;
    $[12] = t5;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t4 || $[16] !== t7) {
    t8 = <>{t4}{t7}</>;
    $[15] = t4;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  return t8;
};
ModularTopNavItems.propTypes = {
  collectionData: PropTypes.array,
  onTopNavClick: PropTypes.func,
  activeCollectionId: PropTypes.number,
  isNavFixed: PropTypes.bool
};
ModularTopNav.propTypes = {
  collectionData: PropTypes.array,
  onTopNavClick: PropTypes.func
};
export default ModularTopNav;
function _temp(c) {
  return c.id;
}
function _temp2(id) {
  return document.getElementById(`collection-${id}`);
}
function _temp3(el) {
  return {
    id: Number(el.id.replace("collection-", "")),
    top: el.getBoundingClientRect().top
  };
}
function _temp4(s) {
  return s.top <= 80;
}
function _temp5(a, b) {
  return b.top - a.top;
}